import { Box } from "@chakra-ui/react";

import { RanaLogoPrimary } from "@nens/ranalib";

import { PublicationOverview } from "./overview";

export const PublicationPublic = () => {
  return (
    <Box>
      <RanaLogoPrimary mb={11} w="lg" maxW="full" />
      <PublicationOverview />
    </Box>
  );
};
